import {Component, ElementRef, OnInit, ViewChild, inject} from '@angular/core';
import Swal from "sweetalert2";
import {DataService} from "../../services/data.service";
import {AccessService} from "../../services/access.service";
import {FormService} from "../../services/form.service";
import {FormBuilder} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {FileType, Right} from "../interfaces";
import {NgFor, NgIf} from '@angular/common';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {FiletypePipe} from '../../pipes/filetype.pipe';

@Component({
    selector: 'app-templates',
    templateUrl: './templates.component.html',
    styleUrl: './templates.component.scss',
    imports: [NgFor, NgIf, TooltipModule, FiletypePipe]
})
export class TemplatesComponent implements OnInit {

    accessService = inject(AccessService);
    formService = inject(FormService);
    private dataService = inject(DataService);
    private fb = inject(FormBuilder);
    private toastrService = inject(ToastrService);

    @ViewChild('fileInput') fileInput: ElementRef;

    readonly Right = Right;

    files: any[] = [];

    ngOnInit(): void {
        this.getFiles();
    }

    triggerFileInput() {
        this.fileInput.nativeElement.click();
    }

    getFiles(): void {
        this.dataService.request('File/listAll', {
            PID: null,
            RID: null,
            category: FileType.TEMPLATE,
        }).subscribe(response => {
            this.files = response.files;
        });
    }

    handleInputChange(e): void {
        for (let i = 0; i < e.target.files.length; i++) {
            const reader = new FileReader();
            reader.onload = (progressEvent) => {
                this.files.push({
                    name: e.target.files[i].name,
                    size: e.target.files[i].size,
                    type: e.target.files[i].type,
                    data: progressEvent.target.result,
                    id: null,
                    category: FileType.TEMPLATE,
                });
                if (i == e.target.files.length - 1) {
                    this.fileInput.nativeElement.value = '';
                }
            };
            reader.readAsDataURL(e.target.files[i]);
        }
    }

    update(): void {
        this.dataService.request('File/save', {
            PID: null,
            RID: null,
            files: this.files,
        }).subscribe(() => {
            this.toastrService.success('Erfolgreich gespeichert')
            this.getFiles();
        });
    }

    deleteFile(file: any): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Der Anhang wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('File/delete', {
                    id: file.id
                }).subscribe(() => {
                    this.getFiles();
                });
            }
        });
    }

    getFileData(file: any): void {
        if (file.id == null) {
            this.openFile(file.data, file.name);
        } else {
            this.dataService.request("File/getData", {
                id: file.id
            }).subscribe(response => {
                if (response.data.data != null) {
                    this.openFile('data:' + response.data.type + ';base64,' + response.data.data, response.data.name);
                }
            });
        }
    }

    deleteOrRemoveFile(file: any) {
        if (file.id == null) {
            this.files.splice(this.files.indexOf(file), 1);
        } else {
            this.deleteFile(file);
        }
    }

    openFile(data: string, name: string): void {
        const link = document.createElement('a');

        link.setAttribute('href', data);
        link.setAttribute('download', name);
        link.click();
    }
}
